import { Box, Divider, useMediaQuery, } from '@mui/material';
import { useTheme, } from '@mui/material/styles';
import CustomLink from '../custom-link';
import LibraryCustomizedTabs from './LibraryCustomizedTabs';
import CreateCustomizedMenu from './CreateCustomizedMenu';

export default function Menu({pages,}) {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.between(1025, 1041));

    return (
        <Box
            component='nav'
            sx={{
                alignItems: 'center',
                flexGrow: 1,
                display: { xs: 'none', lg: 'flex', },
            }}>
            {
                pages.map((page, index) => (
                    <CustomLink
                        key={page.name}
                        to={page.link}
                        sx={{
                            color: 'text.primary',
                            fontSize: 15,
                            fontWeight: 500,
                            mr: (pages.length - 1) === index ? 2 : 1.5,
                            '&:hover': {
                                color: 'secondary.main',
                            },
                        }}
                    >{page.name}</CustomLink>)
                )
            }
            {
                <>
                    <LibraryCustomizedTabs sx={{ml: 2,}} />
                    <Divider
                        flexItem
                        orientation='vertical'
                        variant='middle'
                        sx={{mx: matches ? 1.5 : 2,}} />
                    <CreateCustomizedMenu />
                </>
            }
        </Box>
    );
}